// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-legend-container {
    display: flex;
    gap: 20px;
    cursor: pointer;
    justify-content: center;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
}
.custom-legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
    opacity: 1;
    transition: opacity 0.2s;
}
.custom-legend-item.inactive {
    opacity: 0.4;
}
.custom-legend-bar {
    width: 18px;
    height: 5px;
    display: inline-block;
    border-radius: 2px;
    margin-right: 3px;
}
.custom-legend-bar-inactive {
    border: 1.5px dashed #666;
}

.risk-legend-container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 15px;
    margin-top: 10px;
}
.risk-legend-item {
    display: flex;
    align-items: center;
    opacity: 1;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    transition: opacity 0.2s;
}
.risk-legend-item.inactive {
    opacity: 0.4;
}
.risk-legend-bar {
    width: 15px;
    height: 15px;
    margin-right: 5px;
    border-radius: 3px;
}
.risk-legend-bar-inactive {
    border: 2px dashed #888;
}

.axis-tick-small {
    font-size: 11px;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/PotDetails.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,wBAAwB;AAC5B;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,wBAAwB;AAC5B;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".custom-legend-container {\n    display: flex;\n    gap: 20px;\n    cursor: pointer;\n    justify-content: center;\n    width: 100%;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n.custom-legend-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    opacity: 1;\n    transition: opacity 0.2s;\n}\n.custom-legend-item.inactive {\n    opacity: 0.4;\n}\n.custom-legend-bar {\n    width: 18px;\n    height: 5px;\n    display: inline-block;\n    border-radius: 2px;\n    margin-right: 3px;\n}\n.custom-legend-bar-inactive {\n    border: 1.5px dashed #666;\n}\n\n.risk-legend-container {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 15px;\n    margin-top: 10px;\n}\n.risk-legend-item {\n    display: flex;\n    align-items: center;\n    opacity: 1;\n    cursor: pointer;\n    user-select: none;\n    transition: opacity 0.2s;\n}\n.risk-legend-item.inactive {\n    opacity: 0.4;\n}\n.risk-legend-bar {\n    width: 15px;\n    height: 15px;\n    margin-right: 5px;\n    border-radius: 3px;\n}\n.risk-legend-bar-inactive {\n    border: 2px dashed #888;\n}\n\n.axis-tick-small {\n    font-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
